export const productResultMessage = (total: number) =>
  `oooba, ${total} resultado${total > 1 ? 's' : ''} encontrado${total > 1 ? 's' : ''}`;
